import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import './slider.scss'

class ImageSlider extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var settings = {
      dots: false,
      slidesToShow: this.props.slides_per_page,
      adaptiveHeight: true,
      infinite: true,
    }

    return (
      <div className="animated_slider">
        <Slider {...settings}>
          {this.props.slides.map((slide, i) => (
            <div className="item" key={i}>
              <div className="img-wrapper">
                <div dangerouslySetInnerHTML={{ __html: slide.image }} />
                {slide.source ? (
                  <span className={'source ' + slide.source_color}>
                    Source: {slide.source}
                  </span>
                ) : (
                  <span className="source" />
                )}
              </div>
              {slide.caption ? (
                <span className={'img-caption ' + slide.source_color}>
                  {slide.caption}
                </span>
              ) : (
                ''
              )}
            </div>
          ))}
        </Slider>
      </div>
    )
  }
}

ImageSlider.propTypes = {
  slides: PropTypes.array,
  slides_per_page: PropTypes.string,
}

export default ImageSlider
